import { OrganizationRoutes } from "@simplyk/common";
import { useRouter } from "next/router";

import { useCurrentUserContext } from "../contexts/CurrentUserContext";
import { isDonorRoute, isOrganizationRoute } from "../helpers/auth";

import { useInitialStatus } from "./useInitialStatus";

export const defaultRedirectionRoute = OrganizationRoutes.Settings;

export const useRedirectionStatus = () => {
  const { userIsLoading, isAuthenticated } = useCurrentUserContext();
  const router = useRouter();

  const { hasDonationForm, hasTicketing, loading: initialStatusLoading } = useInitialStatus();

  const hasForm = hasDonationForm || hasTicketing;
  const isLoading = userIsLoading || initialStatusLoading;

  return {
    hasForm,
    isLoading,
    shouldBeInDonorDashboard: isDonorRoute(router.pathname),
    shouldBeInOrganizationDashboard: isOrganizationRoute(router.pathname),
    shouldBeLoggedOut: !userIsLoading && !isAuthenticated,
  };
};
